var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10058_1028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.6C14.7732 7.6 17.6923 9.304 19.1173 12C17.6923 14.696 14.7818 16.4 11.5 16.4C8.21818 16.4 5.30773 14.696 3.88273 12C5.30773 9.304 8.22682 7.6 11.5 7.6ZM11.5 6C7.18182 6 3.49409 8.488 2 12C3.49409 15.512 7.18182 18 11.5 18C15.8182 18 19.5059 15.512 21 12C19.5059 8.488 15.8182 6 11.5 6ZM11.5 10C12.6918 10 13.6591 10.896 13.6591 12C13.6591 13.104 12.6918 14 11.5 14C10.3082 14 9.34091 13.104 9.34091 12C9.34091 10.896 10.3082 10 11.5 10ZM11.5 8.4C9.35818 8.4 7.61364 10.016 7.61364 12C7.61364 13.984 9.35818 15.6 11.5 15.6C13.6418 15.6 15.3864 13.984 15.3864 12C15.3864 10.016 13.6418 8.4 11.5 8.4Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10058_1028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeball);
export default __webpack_public_path__ + "static/media/eyeball.97a4a30fd2fa10b2066e8852b09aeb09.svg";
export { ForwardRef as ReactComponent };